import RemindAPI from 'lib/RemindAPI';
import { stripTypename } from '../utils';
import { DEFAULT_ACTION_ERROR } from 'translations/types';
import DETECT_LANGUAGE_QUERY from '../queries/DetectLanguageQuery.gql';

export async function detectLanguage(text: string) {
  const { translations: resp } = await RemindAPI.execute<any>({
    query: DETECT_LANGUAGE_QUERY,
    variables: { input: { text } },
  });
  const data = resp?.detectLanguage?.data;
  const error = resp?.detectLanguage?.error;

  if (error || !data) {
    return {
      success: false,
      ...(error ? stripTypename(error) : DEFAULT_ACTION_ERROR),
    };
  } else {
    return { success: true, languageCode: data.languageCode };
  }
}
